// import React from 'react'
// import "./RulesBanner.css"

// const RulesBanner = ({ isRtl }) => {
//     const content = isRtl
//         ? {
//             heading: "نظام متكامل لإدارة الموارد البشرية و شؤون الموظفين في دولة الإمارات العربية المتحدة",
//             paragraph1: "تمكنك منصة اتش ار باس من تنظيم ملفات المنشأة وإدارة شؤون الموظفين وحساب الرواتب بالتوافق مع قوانين و اشتراطات وزارة الموارد البشرية والتوطين  في الدولة.",
//             imgSrc: IMG3
//         }
//         : {
//             heading: "ALL-IN-ONE HR system for managing employee affairs in the United Arab Emirates",
//             paragraph1:"HR PASS is a comprehensive platform that enables you to organize the company’s files, manage employee affairs, and calculate salaries following the laws and requirements of the Ministry of Human Resources and Emiratisation in the country.",
//             imgSrc: IMG3
//         };

//     return (
//         <>
//             <div className="RuleBannerSection">
//                 <div className="container-fluid containerSpacing">
//                     <div className="row">
//                         <div className="col-lg-3 col-md-6 col-12">
//                             <div className="ruleBannerItem">
//                                 <img src={ } alt='' className='ruleBannerImg' />
//                                 <h2 className="title">

//                                 </h2>
//                                 <p className="desc">

//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default RulesBanner


import React from 'react';
import "./RulesBanner.css";
import Img1 from "../../assets/images/ruleBanner/Dollardown.png"
import Img2 from "../../assets/images/ruleBanner/time.png"
import Img3 from "../../assets/images/ruleBanner/file.png"
import Img4 from "../../assets/images/ruleBanner/balance.png"

const RulesBanner = ({ isRtl }) => {
    // Define the data inside the file
    const data = [
        {
            headingLtr: "Cost Reduction",
            headingRtl: "خفض التكاليف",
            paragraphLtr: "By integrating HR Pass with advanced technology and automation tools, you can streamline internal operations, significantly cutting down on operational costs. Automating tasks and processes instead of relying on manual work will lead to more efficient resource management and increased savings.",
            paragraphRtl: "استخدام منصة اتش ار باس بالتكنولوجيا وأدوات الأتمتة في إدارة العمليات داخل المنشأة ستسهم بشكل كبير في تقليل التكاليف التشغيلية عن طريق أداء المهام والعمليات ب شكل تلقائي بدلا من القيام بها بوساطة الموظفين.",
            imgSrc: Img1
        },
        {
            headingLtr: "Time Savings",
            headingRtl: "توفير الوقت",
            paragraphLtr: "HR Pass helps you cut down on the time spent on HR tasks, payroll management, and public relations, enabling you to allocate more time for strategic activities and growth.",
            paragraphRtl: "اختصر الوقت المستغرق في مهام الموارد البشرية ومسير الرواتب والعلاقات العامة",
            imgSrc: Img2
        },
        {
            headingLtr: "Reporting & Analysis",
            headingRtl: "التقارير والتحليلات",
            paragraphLtr: "The HR Pass system generates detailed and accurate reports for both your facility and employees at any time. These insights allow you to identify inefficiencies, optimize resources, lower costs, and avoid potential penalties.",
            paragraphRtl: "أنظمة اتش ار باس توفر تقارير دقيقة وشاملة للمنشأة والموظفين في أي وقت. يمكنك من خلال هذه التقارير معرفة نقاط الضعف وتقليل التكاليف وتجنب الغرامات.",
            imgSrc: Img3
        },
        {
            headingLtr: "UAE Labor Law Complianc",
            headingRtl: "ﻣﻄﺎﺑﻘﺔ اﻟﻘﻮاﻧﻴﻦ",
            paragraphLtr: "HR Pass ensures that all internal policies and operations are fully aligned with UAE Labor Law and the regulations set by the Ministry of Human Resources and Emiratization. This guarantees compliance without the need to introduce new laws, preserving workflow efficiency and legal integrity.",
            paragraphRtl: "أﻧﻈﻤﺔ اﺗﺶ آر ﺑﺎس ﺗــﺘﻄـﺎﺑﻖ ﻣﻊ اﻟﻘـﻮاﻧــﻴﻦ و اﻻﺷـــــــــﺘﺮاﻃﺎت ﻟﻘـﺎﻧﻮن اﻟﻌﻤﻞ اﻹﻣﺎراﺗﻲ، ﻛﻤﺎ ﺗـﻮاﺋﻢ ﺟـﻤﻴﻊ ﻟﻮاﺋـﺢ اﻟﻤﻨﺸـــــﺄة اﻟﺪاﺧـﻠـﻴﺔ ﻣﻊ ﻗﻮاﻧﻴﻦ وزارة اﻟﻤﻮارد اﻟﺒﺸـﺮﻳﺔ واﻟﺘﻮﻃﻴﻦ، دون اﻟﺤـﺎﺟﺔ إﻟﻰ اﺳــﺘﺤﺪاث ﻗـﻮاﻧﻴﻦ ﺟﺪﻳﺪة ﻗﺪ ﺗﺆﺛﺮ ﺳﻴﺮ اﻟﻌﻤﻞ.",
            imgSrc: Img4
        }
    ];

    // Helper function to get content based on RTL or LTR
    const getContent = (item) => ({
        heading: isRtl ? item.headingRtl : item.headingLtr,
        paragraph: isRtl ? item.paragraphRtl : item.paragraphLtr,
        imgSrc: item.imgSrc
    });

    return (
        <div className={`RuleBannerSection ${isRtl ? 'rtl' : 'ltr'}`}>
            <div className="container-fluid containerSpacing">
                <div className="row">
                    {data.map((item, index) => {
                        const content = getContent(item);
                        return (
                            <div key={index} className="col-lg-3 col-md-6 col-12">
                                <div className="ruleBannerItem">
                                    <img src={content.imgSrc} alt={content.heading} className="ruleBannerImg" />
                                    <h2 className="title">{content.heading}</h2>
                                    <p className="desc">{content.paragraph}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RulesBanner;
